import { css } from 'lit';

export const style = css`
  @media (min-width: 744px) {
    .checkout-identity-edit {
      display: flex;
    }

    fs-text-field {
      width: 50%;
    }

    .dob {
      margin-right: 1rem;
    }
  }

  fs-text-field {
    margin-bottom: 1rem;
  }
`;
